import { useEffect, useState } from "react";
import ProducerBubble from "../Components/ProducerBubble";
import { getProducers } from "../services/producerService";

export default function ProducersPage() {
    const [producers, setProducers] = useState([]);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState("");

    const hasImage = (img) =>
        typeof img === "string" &&
        img.trim() !== "" &&
        img.trim().toLowerCase() !== "null";

    const fetchProducers = async () => {
        setLoading(true);
        setError("");
        try {
            const response = await getProducers();
            const onlyPassEventProducers = response.filter(
                (producer) =>
                    producer.source === "passevent" && hasImage(producer.img)
            );
            setProducers(onlyPassEventProducers);
        } catch (fetchError) {
            setError(
                fetchError.message || "No se pudieron cargar las productoras."
            );
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        fetchProducers();
    }, []);

    return (
        <div className="relative min-h-screen w-full overflow-hidden bg-zinc-950 text-white">
            <div
                className="pointer-events-none absolute inset-0 opacity-70"
                aria-hidden="true"
                style={{
                    background:
                        "radial-gradient(circle at 16% 18%, rgba(255, 74, 110, 0.20), transparent 34%), radial-gradient(circle at 84% 14%, rgba(59, 130, 246, 0.14), transparent 28%), radial-gradient(circle at 55% 85%, rgba(250, 204, 21, 0.08), transparent 36%)",
                }}
            />

            <div className="relative mx-auto max-w-6xl px-4 pb-16 pt-24">
                <section className="rounded-3xl border border-zinc-800/80 bg-zinc-900/55 p-6 shadow-[0_0_0_1px_rgba(255,255,255,0.02),0_20px_60px_rgba(0,0,0,0.35)] backdrop-blur-sm sm:p-8">
                    <div className="mb-8">
                        <div>
                            <h1 className="text-3xl font-bold text-white md:text-4xl">
                                Productoras
                            </h1>
                            <p className="mt-2 text-sm text-zinc-300">
                                Conocé las productoras activas que publican
                                eventos en PassEvent y CatPass.
                            </p>
                        </div>
                    </div>

                    {loading ? (
                        <div className="rounded-2xl border border-zinc-800 bg-zinc-900/60 p-8 text-center text-zinc-300">
                            Cargando productoras...
                        </div>
                    ) : error ? (
                        <div className="rounded-2xl border border-red-500/30 bg-red-500/10 p-8 text-center text-red-300">
                            {error}
                        </div>
                    ) : producers.length === 0 ? (
                        <div className="rounded-2xl border border-zinc-800 bg-zinc-900/60 p-8 text-center text-zinc-300">
                            No hay productoras.
                        </div>
                    ) : (
                        <div className="grid grid-cols-1 gap-5 sm:grid-cols-2 lg:grid-cols-3">
                            {producers.map((producer) => (
                                <ProducerBubble
                                    key={producer.uniqueId || producer.name}
                                    producer={producer}
                                />
                            ))}
                        </div>
                    )}
                </section>
            </div>
        </div>
    );
}
